// services/holidayService.js
import { apiClient } from "../../../base/ApiClient";

export const getHolidays = async (candidateId, page = 1, year = null, status = null) => {
  let url = `candidate/holidays/?page=${page}`;
  if (candidateId) {
    url += `&candidate=${candidateId}`;
  }
  if (year) {
    url += `&year=${year}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  const res = await apiClient.get(url);
  return res.data;
};

export const getHolidaySummary = async (candidateId, year) => {
  const res = await apiClient.get(`candidate/holidays/summary/?candidate=${candidateId}&year=${year}`);
  return res.data;
};

export const getHolidayBalance = async (candidateId, year) => {
  const res = await apiClient.get(`candidate/holidays/balance/?candidate=${candidateId}&year=${year}`);
  return res.data;
};

export const getHolidayYears = async (candidateId) => {
  const res = await apiClient.get(`candidate/holidays/years/?candidate=${candidateId}`);
  return res.data;
};

export const createHoliday = async (body) => {
  const res = await apiClient.post(`candidate/holidays/`, body);
  return res.data;
};

export const updateHolidaySummary = async (body) => {
  const res = await apiClient.post(`candidate/holidays/update-summary/`, body);
  return res.data;
};

export const updateHoliday = async (id, body) => {
  const res = await apiClient.patch(`candidate/holidays/${id}/`, body);
  return res.data;
};

export const deleteHoliday = async (id) => {
  await apiClient.delete(`candidate/holidays/${id}/`);
};

export const approveHoliday = async (id) => {
  const res = await apiClient.post(`candidate/holidays/${id}/approve/`);
  return res.data;
};

export const rejectHoliday = async (id) => {
  const res = await apiClient.post(`candidate/holidays/${id}/reject/`);
  return res.data;
};

export const createHolidaySummary = updateHolidaySummary;